var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "estate-show" },
    [
      _vm.showCalculateMortgage
        ? _c("calculate-mortgage", {
            attrs: {
              price: _vm.estate.numeric_price,
              durations: _vm.mortgageDurations,
              options: _vm.estate.mortgage_data,
              "estate-id": _vm.estate.id
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCalculateMortgage
        ? _c("custom-offer", { attrs: { estate: _vm.estate } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "sticky",
        { staticClass: "estate-data-container" },
        [
          _c("estate-data", {
            attrs: {
              estate: _vm.estate,
              "back-link": _vm.backLink,
              lang: _vm.lang
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("breadcrumb"),
      _vm._v(" "),
      _c("div", { staticClass: "estate-detail" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "section",
            [
              _c("estate-media", {
                attrs: { estate: _vm.estate, config_estate: _vm.config_estate }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("section", [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-8" },
                  [
                    _vm.estate.ad_type === "estate"
                      ? _c(
                          "estate-content",
                          {
                            attrs: {
                              config_estate: _vm.config_estate,
                              estate: _vm.estate,
                              "show-calculate-mortgage":
                                _vm.showCalculateMortgage
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [_vm._t("estate-title")],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "template",
                              { slot: "subtitle" },
                              [_vm._t("estate-subtitle")],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "template",
                              { slot: "description" },
                              [_vm._t("estate-description")],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "template",
                              { slot: "features" },
                              [_vm._t("estate-features")],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "template",
                              { slot: "costs" },
                              [_vm._t("estate-costs")],
                              2
                            )
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.estate.ad_type === "construction"
                      ? _c(
                          "construction-content",
                          { attrs: { estate: _vm.estate } },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [_vm._t("estate-title")],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "template",
                              { slot: "description" },
                              [_vm._t("estate-description")],
                              2
                            )
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("energy-data", {
                      attrs: { estate: _vm.estate, version: 1 }
                    }),
                    _vm._v(" "),
                    _vm.config_estate.services && _vm.estate.services
                      ? _c("estate-service", {
                          attrs: { services: _vm.estate.services }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.estate.is_tag
                      ? _c("estate-tag", { attrs: { estate: _vm.estate } })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.$root.is_mobile
                      ? _c(
                          "div",
                          { staticClass: "map" },
                          [
                            _c(
                              "modal-opener",
                              {
                                attrs: {
                                  name: "media-gallery",
                                  data: {
                                    estate: _vm.estate,
                                    first_active: "map",
                                    buttons: true
                                  }
                                }
                              },
                              [
                                _c("div", [
                                  _c("img", {
                                    attrs: { src: "/img/icons/expand.svg" }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm.trans("labels.expand")
                                        )
                                      )
                                    )
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("detail-map", {
                              attrs: {
                                latitude: _vm.estate.latitude,
                                longitude: _vm.estate.longitude,
                                "tecnomaps-endpoint": _vm.mapsEndpoint,
                                exact: _vm.estate.show_map ? true : false,
                                marker: _vm.mapsMarker
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.estate.ad_type === "estate"
                      ? _c("div", { staticClass: "row mt-2" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 p-0" },
                            [
                              _c("similar-estates", {
                                attrs: { estate: _vm.estate }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "leads-column col-sm-4 pr-0" },
                  [
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "appointment",
                          staticStyle: {
                            "background-image":
                              "url('/img/icons/icon_appointment.svg')"
                          },
                          on: { click: _vm.openAppointmentModal }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "btn btn-network",
                              class: "btn-network-" + _vm.estate.network
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm.trans("labels.appointment")
                                  )
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "agency-card",
                      {
                        attrs: {
                          "track-phone": true,
                          "estate-type": _vm.estate.ad_type,
                          "estate-id": _vm.estate.id,
                          agency: _vm.estate.agency,
                          "show-email": false,
                          "team-per-page": [
                            [0, 2],
                            [769, 3]
                          ]
                        }
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("div", { staticClass: "agency-card-header" }, [
                            _c("h4", [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(
                                    _vm.trans("labels.estate_by", {
                                      network:
                                        _vm.lang.labels[
                                          _vm.estate.network + "_uc"
                                        ]
                                    })
                                  ) +
                                  "\n                                        "
                              )
                            ])
                          ])
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "sticky",
                      { attrs: { "header-offset": 91 } },
                      [
                        _c(
                          "tabs",
                          { ref: "tabs", staticClass: "lead-forms" },
                          [
                            _c(
                              "template",
                              { slot: "tabs-content" },
                              [
                                _c(
                                  "tab",
                                  {
                                    key: 0,
                                    attrs: {
                                      name: _vm._f("capitalize")(
                                        _vm.trans("labels.lead")
                                      ),
                                      selected: true,
                                      id: 0
                                    }
                                  },
                                  [
                                    _c("lead-form", {
                                      attrs: { estate: _vm.estate }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "appointment_estate",
          attrs: {
            name: "appointment_estate",
            title: _vm.lang.labels.appointment,
            "extra-class": "appointment-modal full-screen-modal"
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [_c("appointment-form", { attrs: { estate: _vm.estate } })],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.config_estate.whatsapp_popup && _vm.estate.agency.whatsapp
        ? _c(
            "div",
            [
              _c("transition", { attrs: { name: "whatsapp" } }, [
                _vm.whatsappPopup
                  ? _c("div", { staticClass: "box_whatsapp" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://wa.me/" + this.estate.agency.whatsapp,
                            target: "_blank"
                          }
                        },
                        [
                          _c("div", { staticClass: "whatsapp_icon" }, [
                            _c("div", {
                              staticClass: "wa-icon",
                              staticStyle: {
                                "mask-image": "url('/img/whatsapp.svg')"
                              },
                              attrs: { alt: "Apri Whatsapp" }
                            })
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }